import Vue from 'vue';
import VueRouter from 'vue-router';
import { Message } from 'element-ui';
Vue.use(VueRouter);

const Routers = [
    // 报备文件-----------------------------------------------------------------------------------------------
    {
        path: '/wybb',
        component: (resolve) => require(['../../views/components/iframe.vue'], resolve),
    },
    {
        path: '/bblb',
        component: (resolve) => require(['../../views/components/iframe.vue'], resolve),
    },
    {
        path: '/bcsmlb',
        component: (resolve) => require(['../../views/components/iframe.vue'], resolve),
    },
    {
        path: '/xzsclb',
        component: (resolve) => require(['../../views/components/iframe.vue'], resolve),
    },
    {
        path: '/sjtj',
        component: (resolve) => require(['../../views/components/iframe.vue'], resolve),
    },
    // 报备系统简化版
    // {
    //     path: '/wybbjhb',
    //     component: (resolve) => require(['../../views/components/iframe.vue'], resolve),
    // },
    {
        path: '/bblbjhb',
        component: (resolve) => require(['../../views/components/iframe.vue'], resolve),
    },
    // 审查系统-----------------------------------------------------------------------------------------------
    {
        path: '/sclb',
        component: (resolve) => require(['../../views/components/iframe.vue'], resolve),
    },
    {
        path: '/hslb',
        component: (resolve) => require(['../../views/components/iframe.vue'], resolve),
    },
    {
        path: '/gglb',
        component: (resolve) => require(['../../views/components/iframe.vue'], resolve),
    },
    {
        path: '/xjgg',
        component: (resolve) => require(['../../views/components/iframe.vue'], resolve),
    },
    {
        path: '/batj',
        component: (resolve) => require(['../../views/components/iframe.vue'], resolve),
    },
    {
        path: '/sctj',
        component: (resolve) => require(['../../views/components/iframe.vue'], resolve),
    },
    {
        path: '/sjzl',
        component: (resolve) => require(['../../views/components/iframe.vue'], resolve),
    },
    {
        path: '/balbCbr',
        component: (resolve) => require(['../../views/components/iframe.vue'], resolve),
    },
    {
        path: '/balbZhcx',
        component: (resolve) => require(['../../views/components/iframe.vue'], resolve),
    },
    {
        path: '/balbLd',
        component: (resolve) => require(['../../views/components/iframe.vue'], resolve),
    },
    {
        path: '/balbCsfzr',
        component: (resolve) => require(['../../views/components/iframe.vue'], resolve),
    },

    // 专项评估-----------------------------------------------------------------------------------------------
    {
        path: '/balbZXPGCbr',
        component: (resolve) => require(['../../views/components/iframe.vue'], resolve),
    },
    {
        path: '/balbZXPGCsfzr',
        component: (resolve) => require(['../../views/components/iframe.vue'], resolve),
    },
    {
        path: '/balbZXPGLd',
        component: (resolve) => require(['../../views/components/iframe.vue'], resolve),
    },
    {
        path: '/gdlbZXPG',
        component: (resolve) => require(['../../views/components/iframe.vue'], resolve),
    },
    {
        path: '/pglbZXPG',
        component: (resolve) => require(['../../views/components/iframe.vue'], resolve),
    },
    {
        path: '/hslbZXPG',
        component: (resolve) => require(['../../views/components/iframe.vue'], resolve),
    },
    {
        path: '/xzscZXPG',
        component: (resolve) => require(['../../views/components/iframe.vue'], resolve),
    },
    {
        path: '/bcsmZXPG',
        component: (resolve) => require(['../../views/components/iframe.vue'], resolve),
    },

    // 历史数据统计-----------------------------------------------------------------------------------------------
    {
        path: '/lssjtj',
        component: (resolve) => require(['../../views/components/iframe.vue'], resolve),
    },
    {
        path: '/lsbatj',
        component: (resolve) => require(['../../views/components/iframe.vue'], resolve),
    },
    {
        path: '/lssctj',
        component: (resolve) => require(['../../views/components/iframe.vue'], resolve),
    },
    // 历史数据-----------------------------------------------------------------------------------------------
    {
        path: '/scxtlssj',
        component: (resolve) => require(['../../views/components/iframe.vue'], resolve),
    },
    {
        path: '/bbxtlssj',
        component: (resolve) => require(['../../views/components/iframe.vue'], resolve),
    },
];

const RouterConfig = {
    mode: 'hash',
    routes: Routers,
};

const router = new VueRouter(RouterConfig);
router.beforeEach((to, from, next) => {
    if (to.path === '/login') {
        next();
    } else {
        // 判断有没有token
        const token = sessionStorage.getItem('token');
        if (token) {
            next();
        } else {
            location.href = '/login';
            Message.warning('请先登录');
        }
    }
});

export default router;
